export const frontendIcons = [
  { image: "../assets/icons/JavaScript.png", label: "JavaScript" },
  { image: "../assets/icons/TypeScript.png", label: "TypeScript" },
  { image: "../assets/icons/React.png", label: "React" },
  { image: "../assets/icons/Redux.png", label: "Redux" },
  { image: "../assets/icons/Jest.png", label: "Jest" },
  { image: "../assets/icons/MaterialUI.png", label: "Material UI" },
  { image: "../assets/icons/Formik.png", label: "Formik" },
  { image: "../assets/icons/HTML5.png", label: "HTML5" },
  { image: "../assets/icons/CSS3.png", label: "CSS" },
  { image: "../assets/icons/Babel.png", label: "Babel" },
  { image: "../assets/icons/NPM.png", label: "NPM" },
  { image: "../assets/icons/Yarn.png", label: "Yarn" },
];
export const backenIcons = [
  { image: "../assets/icons/Java.png", label: "Java" },
  { image: "../assets/icons/JUnit.png", label: "JUnit" },
  { image: "../assets/icons/Spring.png", label: "Spring Boot" },
  { image: "../assets/icons/rest-api.png", label: "REST API" },
  { image: "../assets/icons/GraphQL.png", label: "GraphQL" },
  { image: "../assets/icons/Hibernate.png", label: "Hibernate" },
  { image: "../assets/icons/Node.js.png", label: "Node JS" },
  { image: "../assets/icons/PostgresSQL.png", label: "PostgresSQL" },
  { image: "../assets/icons/MongoDB.png", label: "MongoDB" },
  { image: "../assets/icons/CassandraDB.png", label: "CassandraDB" },
  { image: "../assets/icons/Splunk.png", label: "Splunk" },
  { image: "../assets/icons/ElasticSearch.png", label: "Elastic" },
  { image: "../assets/icons/Logstash.png", label: "Logstash" },
  { image: "../assets/icons/ApacheTomcat.png", label: "ApacheTomcat" },
  { image: "../assets/icons/Kafka.png", label: "Kafka" },
];

export const devOpsIcons = [
  { image: "../assets/icons/GitHub.png", label: "Git" },
  { image: "../assets/icons/Docker.png", label: "Docker" },
  { image: "../assets/icons/Kubernetes.png", label: "Kubernetes" },
  { image: "../assets/icons/Jenkins.png", label: "Jenkins" },
  { image: "../assets/icons/GitHubActions.png", label: "GitHubActions" },
  { image: "../assets/icons/AWS.png", label: "AWS" },
];
